export const mainFilterFunc = {
  data() {
    return {
      currSegments: [],
      currPrices: [],
      currRents: [],
      currTransmission: [], //used only --> motor/version <--
    };
  },
  computed: {
    handlePricesRanges() {
      let arr = [];
      if (this.currPage == "Motor")
        arr = this.filterByTransmission(
          this.getModelEngines(this.resumeData.modelid)
        );
      if (this.currPage == "Version")
        arr = this.filterByTransmission(
          this.versionsLst(this.resumeData.modelid, this.resumeData.engineID)
        );

      if (arr.length == 0) return false;
      return {
        maxPrice: this.getMinMax2(arr, "price", true).price,
        minPrice: this.getMinMax2(arr, "price").price,
        maxRent: this.getMinMax2(arr, "rent", true).rent,
        minRent: this.getMinMax2(arr, "rent").rent,
      };
    },
    setTransmissions() {
      let arr = [];
      let currArr = [];
      if (this.currPage == "Motor")
        currArr = this.getModelEngines(this.resumeData.modelid);
      if (this.currPage == "Version")
        currArr = this.versionsLst(
          this.resumeData.modelid,
          this.resumeData.engineID
        );

      currArr.forEach((el) => {
        if (!arr.includes(el.transmission)) arr.push(el.transmission);
      });
      return arr;
    },
  },
  methods: {
    filterBySegments(arr) {
      return arr.filter((el) =>
        el.segments.find((el) => this.currSegments.includes(el.id))
      );
    },
    filterByTransmission(arr) {
      return arr.filter((el) =>
        this.currTransmission.includes(el.transmission)
      );
    },
    filterByPrice(arr) {
      return arr.filter((el) => {
        let state = false;
        this.currPrices.forEach((item) => {
          let min = 0;
          let max = 999999999;

          if (item == "cfg_price15") max = 15000;
          if (item == "cfg_price25") {
            min = 15000;
            max = 25000;
          }
          if (item == "cfg_price35") {
            min = 25000;
            max = 35000;
          }
          if (item == "cfg_price35up") min = 35000;
          if (el.price >= min && el.price < max) state = true;
        });

        if (state) return el;
      });
    },
    filterByRent(arr) {
      return arr.filter((el) => {
        let state = false;
        this.currRents.forEach((item) => {
          let min = 0;
          let max = 9999999;

          if (item == "cfg_rent_200") max = 200;
          if (item == "cfg_rent_300") {
            min = 200;
            max = 300;
          }
          if (item == "cfg_rent_400") {
            min = 300;
            max = 400;
          }
          if (item == "cfg_rent_400up") min = 400;
          if (el.rent >= min && el.rent < max) state = true;
        });

        if (state) return el;
      });
    },
    getMinMax2(_arr, atrb, max = false) {
      if (_arr.length == 0) return 0;
      if (max)
        return _arr.reduce((prev, curr) =>
          prev[atrb] > curr[atrb] ? prev : curr
        );
      return _arr.reduce((prev, curr) =>
        prev[atrb] < curr[atrb] ? prev : curr
      );
    },
  },
};
